/**
 * The closed sets a field collection's dropdowns offer.
 *
 * Each is a database enum, and the order here is the order somebody reads in
 * the form -- not alphabetical, and not the order Postgres happens to return.
 * The translations live under the `collections` namespace by the same keys.
 */
export const SUBSTRATES   = ['live_trunk', 'dead_trunk', 'live_leaf', 'dead_leaf', 'dung', 'roots', 'soil', 'on_another_fungus', 'carcass', 'other'];
export const SIZES        = ['under_1cm', '1_to_2cm', '2_to_5cm', '5_to_10cm', 'over_10cm'];
export const STAGES       = ['young', 'open', 'mature', 'old'];
export const GROWTH_PATTERNS = ['single', 'clustered', 'spread'];
export const RANKS        = ['species', 'genus', 'family', 'unknown'];
export const CONFIDENCE   = ['certain', 'uncertain'];
export const LAB_STATUSES = ['not_submitted', 'in_progress', 'completed', 'rejected', 'no_lab_sample', 'pending_intake'];
export const IDENT_METHODS = ['field', 'morphology', 'spore_print', 'DNA'];
